"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Header = /*#__PURE__*/function () {
  function Header(page) {
    var _this = this;
    _classCallCheck(this, Header);
    this.DEFAULT_HEADER_HEIGHT = page.platform.isPhone() ? 55 : 85;
    this.HEADER_COLLAPSED_DIFFERENCE = page.platform.isPhone() ? 0 : 30;
    this.container = $("body > header");
    this.innerContainer = $(".inner", this.container);
    this.headerHeight = this.DEFAULT_HEADER_HEIGHT;
    this.window = $(window);
    this.wrapper;
    this.setHeight();
    var sticky = new Waypoint.Sticky({
      element: this.container,
      offset: 0,
      stuckClass: 'stuck'
    });
    this.wrapper = $(sticky.wrapper);
    this.window.scroll(function () {
      _this.setHeight();
    });
  }
  return _createClass(Header, [{
    key: "getHeight",
    value: function getHeight() {
      return this.headerHeight;
    }
  }, {
    key: "setHeight",
    value: function setHeight() {
      var difference = Math.min(this.window.scrollTop() * 0.2, this.HEADER_COLLAPSED_DIFFERENCE);
      this.headerHeight = Math.min(this.DEFAULT_HEADER_HEIGHT - difference, 85);
      var styles = {
        height: this.headerHeight
      };
      this.container.css(styles);
      this.innerContainer.css(styles);
      if (this.wrapper) {
        $(this.wrapper).css(styles);
      }
    }
  }]);
}();